import moment from "moment";
import * as Sentry from "@sentry/browser";

export const defaultList = () => {
    return {
        count: 0,
        next: null,
        previous: null,
        results: [],
    };
};

export const daysFrom = (endDate, startDate) => {
    const momentEnd = moment(endDate, moment.ISO_8601, true).startOf('day');
    const momentStart = moment(startDate).startOf('day');
    return Math.round(momentEnd.diff(momentStart, 'days', true));
};

export const logRequestError = error => {
    Sentry.captureException(error, {
        extra: {
            request: error.request,
            response: error.request.response
        }
    });
};
